import { Component, OnInit } from '@angular/core';
import { AddNewLaundryCustomerService } from '../services/add-new-laundry-customer.service';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'cintas-add-new-laundry-customer',
  templateUrl: './add-new-laundry-customer.component.html',
  styleUrls: ['./add-new-laundry-customer.component.scss']
})

export class AddNewLaundryCustomerComponent implements OnInit {

  ngOnInit(): void {
      
  }
  constructor(private AddNewLaundryCustomerService: AddNewLaundryCustomerService) {
    // translate.addLangs(["en", "de"]); 
    // translate.setDefaultLang('en');
    // const browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
  } 
  // switchLanguage(language: string) {
  //   this.translate.use(language);
  // }

  onSubmit(customerData: any): void {
    // event.preventDefault();
    this.AddNewLaundryCustomerService.addCustomer(customerData).subscribe(
      (response) => {
        console.log('Customer added successfully', response);
        alert('Customer added successfully');
        window.location.reload();
      },
      (error) => {
        console.error('Please Try Again! Error adding customer', error);
        alert('Please Try Again! Error adding customer'+ error);
        window.location.reload();
      }
    );
  }
}
